
import * as Api from "@/types/graphql";
import _ from "lodash";
import { Component, Prop, Vue } from "vue-property-decorator";
import { Mutation, State } from "vuex-class";
import { State as StateStore } from "../store";

@Component({
  watch: {
    selectedServicesState(val) {
      this.selectedServices = val;
    },
    hiddenServices() {
      this.initItems();
    },
  },
})
export default class MultipleServicesSelector extends Vue {
  @State((state: StateStore) => state.auth.user) user: Api.User;
  @State((state: StateStore) => state.data.services) servicesState: Api.Service[];
  @State((state: StateStore) => state.data.selectedServices) selectedServicesState: Api.Service[];

  @Mutation addSelectedServices;
  @Mutation removeSelectedService;
  @Mutation setSelectedServices;
  @Mutation resetSelectedServices;

  @Prop({ default: "Seleziona servizi" }) label: string;
  @Prop() hiddenServices: Api.Service[];
  @Prop({ default: true }) multiple: boolean;

  options: any[] = [];
  selectedServices: Api.Service[] = [];

  async mounted() {
    this.selectedServices = this.selectedServicesState;
    this.initItems();
  }

  initItems() {
    this.options = []; // Reset options on re-init

    const services = this.hiddenServices
      ? this.servicesState.filter(service =>
          !this.hiddenServices.some(hidden => hidden.guid === service.guid)
        )
      : this.servicesState;

    this.initOptions(services);
  }

  initOptions(services: Api.Service[]) {
    const grouped = _.groupBy(services, "servicetype.des");
    for (const [group, items] of Object.entries(grouped)) {
      this.options.push({ header: group });
      this.options.push(...items);
    }
  }

  filter(item, queryText) {
    if (item.header || (queryText as string)?.length < 3) return false;
    return item.des.toLowerCase().includes(queryText.toLowerCase());
  }

  isSelected(service) {
    return this.selectedServicesState.some(s => s.guid === service.guid);
  }

  onChange(services: Api.Service[]) {
    const validServices = services.filter(service => service && service.guid);
    this.setSelectedServices(validServices);
  }

  removeSelected(service: Api.Service) {
    const updated = this.selectedServicesState.filter(s => s.guid !== service.guid);
    this.setSelectedServices(updated);
  }
}
